import React from "react";
import { about, gallery, contact } from "../../mock";
import { Eyebrow } from "../SectionHeading";
import Reveal from "../Reveal";
import WhatsAppImage from "../WhatsAppImage";
import { MessageCircle, ShieldCheck } from "lucide-react";

const AboutSection = () => {
  return (
    <section className="py-20 md:py-28 bg-[#08080f] relative overflow-hidden">
      <div className="glow-blob w-80 h-80 bg-[#00e5ff] -top-10 left-0" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <div className="grid grid-cols-2 gap-4">
              {gallery.map((g, i) => (
                <WhatsAppImage
                  key={g}
                  src={g}
                  alt={`DaddyAnna online cricket id ${i + 1}`}
                  rounded="rounded-xl"
                  className={`aspect-square ${i % 2 === 0 ? "mt-0" : "mt-8"}`}
                />
              ))}
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div>
              <Eyebrow>About Cricket ID</Eyebrow>
              <h2 className="font-display text-3xl sm:text-4xl font-bold text-white leading-tight">
                {about.heading}
              </h2>
              {about.paragraphs.map((p, i) => (
                <p key={i} className="mt-5 text-gray-400 leading-relaxed">
                  {p}
                </p>
              ))}

              <div className="mt-6 flex items-center gap-3 text-[#00ff87] font-semibold">
                <ShieldCheck size={20} /> 18+ Only · Play Responsibly · Trusted since 2015
              </div>

              <a
                href={contact.whatsapp}
                target="_blank"
                rel="noreferrer"
                className="btn-neon mt-7 inline-flex items-center gap-2 px-7 py-3.5 rounded-xl font-display font-semibold"
              >
                <MessageCircle size={20} /> Get Your ID
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
